import { Grid } from "@material-ui/core";
import BN from "bn.js";
import { round } from "lodash";
import moment from "moment";
import { FunctionComponent, useContext } from "react";
import styled from "styled-components";
import { Code } from "../../../../components/typography";
import { formatDecimal, formatEther } from "../../../../utils/utils";
import { StakeContext } from "../context";
import { StyledTextWidget } from "./tile";

interface IStatsProps { }

const GridItem = styled(Grid).attrs({ item: true })`
  :nth-child(2n) {
    font-weight: bold;
  }
`;

const StyledGrid = styled(Grid)`
  margin-top: 0.8em;
`;

const Stats: FunctionComponent<IStatsProps> = (props) => {
  const { currentContract, stakingContractId } = useContext(StakeContext);

  return currentContract.fold(
    () => null,
    (contract) => (
      <StyledTextWidget title="Rewards Contract Information">
        <StyledGrid container spacing={3}>
          <GridItem xs={6}>Locked staking period</GridItem>
          <GridItem xs={6}>
            {round(
              moment()
                .add(contract.lockedPeriodDays, "days")
                .diff(moment(), "months", true)
            )}{" "}
            months
          </GridItem>
          <GridItem xs={6}>Rewards maturity</GridItem>
          <GridItem xs={6}>
            {round(
              moment()
                .add(contract.stakingMaturityDays, "days")
                .diff(moment(), "months", true)
            )}{" "}
            months
          </GridItem>
          <GridItem xs={6}>
            Claim <strong>before</strong>{" "}
            {round(
              moment()
                .add(contract.firstPenaltyPeriodDays, "days")
                .diff(moment(), "months", true)
            )}{" "}
            months
          </GridItem>
          <GridItem xs={6}>
            {contract.firstUnStakePenalty}% of earned rewards
          </GridItem>
          <GridItem xs={6}>
            Claim <strong>between</strong>{" "}
            {round(
              moment()
                .add(contract.firstPenaltyPeriodDays, "days")
                .diff(moment(), "months", true)
            )}{" "}
            and{" "}
            {round(
              moment()
                .add(contract.stakingMaturityDays, "days")
                .diff(moment(), "months", true)
            )}{" "}
            months
          </GridItem>
          <GridItem xs={6}>
            {contract.secondUnStakePenalty}% of earned rewards
          </GridItem>
          <GridItem xs={6}>
            Claim <strong>at maturity</strong>
          </GridItem>
          <GridItem xs={6}>100% of earned rewards</GridItem>
          {currentContract
            .map((x) => x.walletInfo)
            .fold(
              () => null,
              ({ minStake, maxStake }) => (
                <>
                  <GridItem xs={6}>Minimum Lock</GridItem>
                  <GridItem xs={6}>$SKRT {formatEther(minStake)}</GridItem>
                  <GridItem xs={6}>Maximum Lock</GridItem>
                  <GridItem xs={6}>$SKRT {formatEther(maxStake)}</GridItem>
                </>
              )
            )}
          <GridItem xs={6}>Contract Address</GridItem>
          <GridItem xs={6}>
            <Code>{stakingContractId}</Code>
          </GridItem>
          <GridItem xs={6}>Pool Capacity</GridItem>
          <GridItem xs={6}>
            {formatDecimal(new BN(contract.stakingPoolSize), 0)} $SKRT
          </GridItem>
        </StyledGrid>
      </StyledTextWidget>
    )
  );
};

export default Stats;
